import React, { useContext } from "react";
import { Form } from "formik";
import { AppContext } from "../../../context";
import TextField from "./TextField";
import { createStyles } from "@mantine/emotion";

const useStyles = createStyles({
  form: {
    marginTop: "16px",
  },
  row: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridGap: "16px",
    "@media (max-width: 667px)": {
      gridTemplateColumns: "1fr",
    },
  },
  row_2_1: {
    gridTemplateColumns: "2fr 1fr",
  },
  row_1_2: {
    gridTemplateColumns: "1fr 2fr",
  },
  footerAction: {
    display: "flex",
    justifyContent: "end",
    gap: "1rem",
    marginTop: "1rem",
  },
});

const addressFields = [
  "street",
  "streetNumber",
  "zipCode",
  "city",
  "countryCode",
];

const ResponsibleForm = (props) => {
  const { hasFee, authenticated, selectedDeliveryMethod } = props;
  const { classes } = useStyles();
  const {
    state: { language, config },
  } = useContext(AppContext);
  const { visibleFields, requiredFields } = config;

  const show = (field) => {
    if (visibleFields.includes(field)) return true;
    if (
      selectedDeliveryMethod &&
      selectedDeliveryMethod.mandatoryAddress &&
      addressFields.includes(field)
    )
      return true;
    return false;
  };

  const required = (field) => {
    if (requiredFields.includes(field)) return true;
    if (
      selectedDeliveryMethod &&
      selectedDeliveryMethod.mandatoryAddress &&
      addressFields.includes(field)
    )
      return true;
    return false;
  };

  return (
    <Form className={classes.form} name={language.Step_Responsible_Head}>
      <div className={classes.row}>
        <TextField
          name="firstName"
          label={language.Responsible_FirstName}
          required={true}
          placeholder={language.Responsible_FirstName}
          disabled={authenticated}
          isGiftCertificate={props.isGiftCertificate}
          autoComplete="off"
        />
        <TextField
          name="lastName"
          label={language.Responsible_LastName}
          required={true}
          placeholder={language.Responsible_LastName}
          disabled={authenticated}
          isGiftCertificate={props.isGiftCertificate}
          autoComplete="off"
        />
      </div>
      <div className={classes.row}>
        {show("civicRegistrationNumber") && (
          <TextField
            name="civicRegistrationNumber"
            label={language.Responsible_CivicRegistrationNumber}
            required={required("civicRegistrationNumber")}
            placeholder={
              language.Responsible_CivicRegistrationNumber_Placeholder
            }
            isGiftCertificate={props.isGiftCertificate}
            autoComplete="off"
          />
        )}
      </div>
      <div className={classes.row}>
        <TextField
          name="email"
          label={language.Responsible_Email}
          required={true}
          placeholder={language.Responsible_Email}
          isGiftCertificate={props.isGiftCertificate}
          autoComplete="off"
        />
        {show("cellPhone") && (
          <TextField
            name="cellPhone"
            type="text"
            label={language.Responsible_CellPhone}
            placeholder={language.Responsible_CellPhone}
            required={required("cellPhone")}
            isGiftCertificate={props.isGiftCertificate}
            autoComplete="off"
          />
        )}
      </div>
      <div className={`${classes.row} ${classes.row_2_1}`}>
        {(show("street") || hasFee) && (
          <TextField
            name="street"
            type="text"
            label={language.Responsible_AddressStreet}
            placeholder={language.Responsible_AddressStreet}
            required={required("street") || hasFee}
            isGiftCertificate={props.isGiftCertificate}
            autoComplete="off"
          />
        )}

        {(show("streetNumber") || hasFee) && (
          <TextField
            name="streetNumber"
            type="text"
            label={language.Responsible_AddressStreetNumber}
            placeholder={language.Responsible_AddressStreetNumber}
            required={required("streetNumber") || hasFee}
            isGiftCertificate={props.isGiftCertificate}
            autoComplete="off"
          />
        )}
      </div>
      <div className={`${classes.row} ${classes.row_1_2}`}>
        {(show("zipCode") || hasFee) && (
          <TextField
            name="zipCode"
            type="number"
            label={language.Responsible_AddressZip}
            placeholder={language.Responsible_AddressZip}
            required={required("zipCode") || hasFee}
            isGiftCertificate={props.isGiftCertificate}
            autoComplete="off"
          />
        )}

        {(show("city") || hasFee) && (
          <TextField
            name="city"
            type="text"
            label={language.Responsible_AddressCity}
            placeholder={language.Responsible_AddressCity}
            required={required("city") || hasFee}
            isGiftCertificate={props.isGiftCertificate}
            autoComplete="off"
          />
        )}
      </div>
      <div className={classes.row}>
        {(show("countryCode") || hasFee) && (
          <TextField
            name="countryCode"
            type="text"
            label={language.Responsible_Country}
            placeholder={language.Responsible_Country}
            required={required("countryCode") || hasFee}
            isGiftCertificate={props.isGiftCertificate}
            autoComplete="off"
          />
        )}
      </div>
    </Form>
  );
};

export default ResponsibleForm;
